import { Component, OnInit, Input } from "@angular/core";
import { CommonService } from "../service/common.service";

@Component({
  selector: "content-list-condition",
  templateUrl: "./condition-content-list.component.html",
})
export class ConditionContentListComponent implements OnInit {
  @Input() md: any;
  @Input() eflg: boolean;
  dupcheckLists: boolean = false;

  constructor(private commonService: CommonService) {}

  ngOnInit() {
    this.changeCondition();
  }
  addRow(row: number): void {
    let sss = {
      t_conditions_s_id: null,
      conditions_s_name: null,
      conjunction: null,
    };
    this.md.data.content.splice(row + 1, 0, sss); // i番目の次に１レコード追加
    this.changeCondition();
  }
  delRow(row: number): void {
    if (this.md.data.content.length == 1) {
      this.md.data.content = [];
      this.addRow(0);
    } else {
      this.md.data.content.splice(row, 1); // i番目を１レコード削除
    }
    this.changeCondition();
  }
  upRow(row: number): void {
    if (row == 0) {
      //最初
    } else {
      this.md.data.content.splice(
        row - 1,
        2,
        this.md.data.content[row],
        this.md.data.content[row - 1]
      );
    }
  }
  downRow(row: number): void {
    if (row == this.md.data.content.length - 1) {
      //最終
    } else {
      this.md.data.content.splice(
        row,
        2,
        this.md.data.content[row + 1],
        this.md.data.content[row]
      );
    }
  }
  changeCondition(): void {
    this.md.dupcheckLists = this.commonService.checkDupRecords(
      this.md.data.content,
      "t_conditions_s_id"
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/a2126-yconditions-group-m/condition-content-list.component.ts